import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { log } from 'util';
import ProductGrid from '../../common/ListingPage/ProductGridDesktop';
import ProductListContainer from '../../common/ListingPage/ProductListingContainer';
import Layout from '../Layout';
import NotFound from '../../common/NotFound';
import Error503 from '../../common/Error503';
import Error504 from '../../common/Error504';
import BreadCrumb from '../../common/BreadCrumb';
import ProductQuickview from '../../common/ListingPage/quickview/ProductQuickview';
import Loader from '../../common/Loader.js';
import properties from '../../../modules/ajio-util/properties';
import SocialSharing from '../../common/CapsulePage/SocialSharing';
import CapsuleSlider from '../../common/CapsulePage/CapsuleSlider';

class Capsule extends React.Component {
  constructor(props) {
    super(props);
  }

  onActionClick = e => {
    const capsuleProducts = document.getElementById('capsule-products');
    const capsuleOffsetTop = capsuleProducts.offsetTop - 120;
    const element = document.body;
    const duration = 500;
    if (duration <= 0) return;
    const difference = capsuleOffsetTop - element.scrollTop;
    const perTick = (difference / duration) * 30;

    setTimeout(function() {
      element.scrollTop += perTick;
      if (element.scrollTop === capsuleOffsetTop) return;
      scrollTo(element, capsuleOffsetTop, duration - 10);
    }, 10);
  };

  render() {
    const {
      rilfnlBreadCrumb = [],
      productsAdditionalInfo = {},
      totalResults,
      pathname,
      category,
      allcapsules = {},
      error = {}
    } = this.props;

    if (error && error.errorCode == '504') {
      return <Error504 name="home" device="desktop" />;
    }
    if (error && error.errorCode == '503') {
      return <Error503 name="home" device="desktop" />;
    }

    const page = this.props.match.params.cid;
    let newinSocialShare = true;

    if (Object.keys(allcapsules).length === 0) {
      return (
        <Layout>
          <div className="main-view-fluid">
            <NotFound mobile={false} />
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <ProductListContainer>
          {props => {
            const {
              searchInput,
              location,
              loadMoreItems,
              pushToHistory,
              replaceInHistory,
              isRequestOrginIsBrowser,
              hasErrored,
              errorDetails,
              categoryDescription
            } = props;
            if (
              !isRequestOrginIsBrowser &&
              hasErrored &&
              errorDetails &&
              (errorDetails.status === 400 || errorDetails.status === 504)
            ) {
              return (
                <div className="main-view main-view-fluid page page--mobile page--category">
                  <NotFound mobile />
                </div>
              );
            }
            if (
              !isRequestOrginIsBrowser &&
              hasErrored &&
              errorDetails &&
              errorDetails.status === 503
            ) {
              return (
                <div className="error-page">
                  <Error503 name="plp" />;
                </div>
              );
            }
            return (
              <div className="main-view page page--category-desktop product-view capsules">
                <div>
                  {rilfnlBreadCrumb.length > 0 ? (
                    <BreadCrumb breadcrumb={rilfnlBreadCrumb} />
                  ) : null}
                  <div className="plp-view">
                    <div className="capsule-container">
                      <h1>{category}: New In Capsule Collections</h1>
                      <CapsuleSlider />
                      <div className="cp-common">
                        <SocialSharing category={category} newinSocialShare={newinSocialShare} />
                        <div className="shopnow">
                          <span className="icon-text">SHOP NOW</span>
                          <div className="sprite-icon shopnow-ic" onClick={this.onActionClick} />
                        </div>
                      </div>
                    </div>
                    <Loader name="quick-view-loader" />
                    <div className="products" id="capsule-products">
                      <ProductGrid searchInput={searchInput} location={location} />
                    </div>
                    <ProductQuickview />
                  </div>
                </div>
              </div>
            );
          }}
        </ProductListContainer>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, request = {}, capsules = {} } = state;
  const { rilfnlBreadCrumbList = {} } = productsAdditionalInfo;
  const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
  const { totalResults, pathname, category = 'women' } = request;
  return {
    rilfnlBreadCrumb,
    productsAdditionalInfo,
    totalResults,
    pathname,
    category,
    allcapsules: capsules
  };
};

export default connect(mapStateToProps)(Capsule);
